import React from 'react';

const NewsletterSignup = () => {
  return (
    <section className="relative py-8 md:py-16 bg-cover bg-center text-white" style={{ backgroundImage: `url('/images/news_banner.jpg')` }}>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12 text-center container">
        <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4">Never Miss An Offer</h2>
        <p className="text-base md:text-lg mb-6 md:mb-8 opacity-90">Subscribe to our newsletter to get the latest updates, news, and special offers directly in your inbox.</p>
        <form className="flex flex-col md:flex-row justify-center px-4 md:px-12 gap-2 md:gap-4">
          <input
            type="email"
            placeholder="Enter your email address"
            className="p-2 md:p-3 rounded-md w-full md:w-2/3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#16A34A]"
          />
          <button
            type="submit"
            className="bg-[#16A34A] hover:bg-[#128a3a] text-white font-bold py-2 md:py-3 px-4 md:px-6 rounded-md transition duration-300 transform hover:scale-105 w-full md:w-1/3"
          >
            Subscribe
          </button>
        </form>
      </div>
    </section>
  );
};

export default NewsletterSignup;